import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
export var HeaderUserImage = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, _b = _a.marginRight, marginRight = _b === void 0 ? '12px' : _b, _c = _a.marginLeft, marginLeft = _c === void 0 ? '12px' : _c, _d = _a.size, size = _d === void 0 ? '30px' : _d;
    return (React.createElement("img", { src: marketplaceStore.userImage, alt: "profile-image", "data-hook": "profile-image", style: {
            height: size,
            width: size,
            marginRight: marginRight,
            marginLeft: marginLeft,
            borderRadius: '50%',
        } }));
});
//# sourceMappingURL=header-user-image.js.map